<template>
  <div class="bg-[#101828] h-full min-h-screen text-white">
    
  <router-view />
</div>
</template>

<script setup>
</script>
